<div class="rightPannelBox relative">
  <div class="container">
    <div class="col-lg-12">
      <h2 class="p-2 mt-2">Select Your Seats</h2>
      <div class="p-2">
        <ng-template [ngIf]="seatSelectionScreen.deckDetails.length > 1">
          <button type="button" role="button" class="btnDeck" [class.deckActive]="activeCabin === 1" (click)="updateDeckScreen()">Upper Deck</button>
          <button type="button" role="button" class="btnDeck" [class.deckActive]="activeCabin === 0" (click)="updateDeckScreen()">Lower Deck</button>
        </ng-template>
      </div>
    </div>
    <div class="float-right closeSeat">
      <button type="button" (click)="closeSeat()" class="ba-btn ba-btn-sq-sm" role="button"><i class="fa fa-times"></i></button>
    </div>
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-8 text-center col-md-8 col-sm-12">
          <div class="row mapPn">
            <div class="col-md-12">
              <div *ngFor="let deckDetails of seatSelectionScreen.deckDetails; let deckIndex = index" class="seat-parent">
                <div [class.dNone]="activeCabin !== deckIndex" *ngFor="let seatRow of deckDetails.layout; let row = index" class="seat-row">
                  <div class="seatcol exitrw exitrwLeft">
                    <div class="exitrow">
                      <i class="fa fa-caret-left fa-3x" *ngIf="checkExitRow(seatRow.rowNumber, 'left', deckIndex)"></i>
                    </div>
                  </div>
                  <div class="seat-row-name seat-col">Row {{ seatRow.rowNumber }}</div>
                  <ng-template [ngIf]="seatRow.leftColumnLayout.length > 0">
                    <div *ngFor="let leftLayout of seatRow.leftColumnLayout; let col = index" class="d-inline-flex">
                      <div *ngIf="checkAlreadyUsedSeat(seatRow.rowNumber, leftLayout.seatColumnName); else availableSeat">
                        <div class="seatcol seatUser seat paxst">
                          <br />
                          <span class="stcol"
                            ><b>{{ getUsedPassengerId(seatRow.rowNumber, leftLayout.seatColumnName) }}</b></span
                          >
                        </div>
                      </div>
                      <ng-template #availableSeat>
                        <div
                          class="seat-col"
                          (click)="makeSelected(row, 'left', col, leftLayout.isSeatAvailable, deckIndex)"
                          [class.visible-hidden]="leftLayout.isOTH"
                          [class.disabled-col]="!leftLayout.isSeatAvailable"
                          [class.pointer]="leftLayout.isSeatAvailable"
                          [class.greenBox]="chechk_active_seat(seatRow.rowNumber, leftLayout.seatColumnName)"
                          [class.brownBox]="chech_selected_seat(seatRow.rowNumber, leftLayout.seatColumnName)"
                        >
                          <ng-template [ngIf]="!chech_selected_seat(seatRow.rowNumber, leftLayout.seatColumnName)">
                            <div>{{ leftLayout.seatColumnName }}</div>
                          </ng-template>
                          <ng-template [ngIf]="chech_selected_seat(seatRow.rowNumber, leftLayout.seatColumnName)">
                            <div class="SeatIcon"></div>
                          </ng-template>
                          <div *ngIf="leftLayout.isSeatAvailable" class="seatpc seatsml">{{ leftLayout.price }} {{ leftLayout.currency }}</div>
                        </div>
                      </ng-template>
                      <ng-template [ngIf]="leftLayout.displayEmptyBox">
                        <div class="dummy-col seat-col">-</div>
                      </ng-template>
                    </div>
                  </ng-template>
                  <div class="seatcol exitrw exitrwRight">
                    <div class="exitrow">
                      <i class="fas fa-caret-right fa-3x" *ngIf="checkExitRow(seatRow.rowNumber, 'right', deckIndex)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="mappxPn pd-10">
            <ng-template [ngIf]="seatSelectionScreen.passengerDetail.length > 0">
              <div
                *ngFor="let passenger of seatSelectionScreen.passengerDetail; let passengerIndex = index"
                (click)="updateActivePassenger(passengerIndex)"
                id="T2-px"
                class="colc pax"
                [class.sel]="passenger.activePasssenger"
              >
                <label class="seatlbno" id="T2-seat" name="T2-seat">{{ passenger.selectedRowNumber }} {{ passenger.selectedColumnName }}</label
                ><br />
                <label class="seatlbno2">{{ passenger.passengerType }}</label>
              </div>
            </ng-template>
          </div>
          <div class="mapbtn seatingRules pd-10">
            <ul>
              <li class="mb-2">Seating Rules:</li>
              <li *ngFor="let rules of seatingRules">{{ rules }}</li>
            </ul>
            <button type="button" (click)="updateSeat()" role="button" class="ba-btn float-right"><i class="baIcn ba-flight-seat ba-2x"> </i> SAVE</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
